import React from "react";
import Stats from "../../GameHeader/Stats/Stats";

const StatsDialog = () => (
  <div className="dialog-content">
    <Stats inDialog={true} />
  </div>
)

export default StatsDialog;
